import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle2, Clock, Layers, XCircle } from "lucide-react";
import { SUMMARY_ACCENT, SURFACE_CARD } from "../styles";
import { StatusCountsType } from "../types";

type SummaryCardsProps = {
  counts: StatusCountsType;
  pendingQuotas: number;
};

type SummaryItemType = {
  key: string;
  label: string;
  value: number;
  icon: typeof Clock;
  accent: string;
};

export const SummaryCards = ({ counts, pendingQuotas }: SummaryCardsProps) => {
  const items: SummaryItemType[] = [
    {
      key: "pending",
      label: "Pendentes",
      value: counts.pending,
      icon: Clock,
      accent: SUMMARY_ACCENT.pending,
    },
    {
      key: "accepted",
      label: "Aceitas",
      value: counts.accepted,
      icon: CheckCircle2,
      accent: SUMMARY_ACCENT.accepted,
    },
    {
      key: "rejected",
      label: "Rejeitadas",
      value: counts.rejected,
      icon: XCircle,
      accent: SUMMARY_ACCENT.rejected,
    },
    {
      key: "quotas",
      label: "Cotas pendentes",
      value: pendingQuotas,
      icon: Layers,
      accent: SUMMARY_ACCENT.neutral,
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
      {items.map(({ key, label, value, icon: Icon, accent }) => {
        const isEmpty = value === 0;

        return (
          <Card key={key} className={`shadow-none ${SURFACE_CARD}`}>
            <CardContent className="flex items-center gap-3 p-4">
              <span
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${
                  isEmpty ? SUMMARY_ACCENT.neutral : accent
                }`}
              >
                <Icon className="h-4 w-4" />
              </span>
              <div className="min-w-0">
                <p className="truncate text-xs font-medium text-muted-foreground">
                  {label}
                </p>
                {/* O número fica neutro: a cor está no ícone, não no dado. */}
                <p
                  className={`text-2xl font-semibold leading-tight tabular-nums ${
                    isEmpty ? "text-muted-foreground" : "text-foreground"
                  }`}
                >
                  {value}
                </p>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
